<template>
    <div class="base-success" :class="{'suc-sp': $store.state.screen == 1}">
        <div class="content">
            <div class="title">领取成功</div>
            <div class="tips">礼包码：<span>{{cardNum}}</span></div>
            <div class="btn">
                <div class="item" @click="onOut">取消</div>
                <div class="item" @click="onCopy">复制</div>
            </div>
            <transition name="component-fade" mode="out-in">
                <TheTips :msg='msg' v-if="msg" />
            </transition>
        </div>
    </div>
</template>

<script>
    import Clipboard from 'clipboard'
    import TheTips   from '@/components/TheTips'

    export default {
        components: {
            TheTips
        },
        props: {
            cardNum: String | Number
        },
        data () {
            return {
                msg: null
            }
        },
        methods: {
            onOut () {
                this.$emit('childSucce', false)
            },
            onCopy (event) {
                let that = this
                const clipboard = new Clipboard(event.target, {
                    text: () => that.cardNum
                })
                clipboard.on('success', () => {
                    that.msg = '复制成功'
                    setTimeout(() => {
                        that.msg = null
                    }, 1000)
                    // 释放内存
                    clipboard.destroy()
                })
                clipboard.on('error', () => {
                    that.msg = '复制失败'
                    setTimeout(() => {
                        that.msg = null
                    }, 1000)
                    // 释放内存
                    clipboard.destroy()
                })
                clipboard.onClick(event)
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../static/tctransition";
    $color: #FF6C22; // 主体颜色
    // 横屏css
    .base-success {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        transition: all 0.3s;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        .content {
            width: 840px;
            overflow: hidden;
            border-radius: 18px;
            background: $color;
            overflow: hidden;
            padding: 0 60px 60px;
            position: relative;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .title {
                height: 160px;
                font-size: 51px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .tips {
                font-size: 42px;
                text-align: center;
                margin-bottom: 50px;
            }
            .btn {
                height: 120px;
                margin-top: 55px;
                display: flex;
                justify-content: space-between;
                .item {
                    width: 345px;
                    height: 120px;
                    color: $color;
                    font-size: 39px;
                    border-radius: 18px;
                    background: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .item:first-child {
                    background: rgba(255, 255, 255, 0.8);
                }
            }
        }
    }
    // 竖屏css
    .suc-sp {
        .content {
            width: 1527px;
            border-radius: 32px;
            padding: 0 90px 90px;
            .title {
                height: 290px;
                font-size: 92px;
            }
            .tips {
                font-size: 76px;
                margin-bottom: 90px;
            }
            .btn {
                height: 200px;
                margin-top: 100px;
                .item {
                    width: 627px;
                    height: 200px;
                    font-size: 70px;
                    border-radius: 32px;
                }
            }
        }
    }
</style>